import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './Underground.css';
import { UndergroundIcon } from './components/UndergroundIcon';
import { GeoTravelTime } from '../GeoTravelTime';
import { IUndergroundMobSiteSchema } from '../../types/recommendation';

export interface IUndergroundProps {
  regionId: number;
  underground: IUndergroundMobSiteSchema;
}

export const Underground: React.FC<IUndergroundProps> = ({ regionId, underground }) => {
  const { lineColor, name, time, transportType, underConstruction } = underground;

  return (
    <div className={clsx(styles['container'], { [styles['under-construction']]: underConstruction })}>
      {lineColor && <UndergroundIcon className={styles['icon']} color={`#${lineColor}`} regionId={[regionId]} />}
      <span className={styles['name']}>
        <UIText2 display="inline">{name}</UIText2>
      </span>
      {time && transportType && <GeoTravelTime time={time} transportType={transportType} />}
    </div>
  );
};
